// Plotly (Python) charts are generated with `include_plotlyjs="cdn"`, which
// bakes a `https://cdn.plot.ly/plotly-<version>.min.js` loader into the chart's
// HTML. cdn.plot.ly does not host every published plotly.js release (e.g. 3.7.0
// returns 403), so charts referencing a missing version render blank with
// "Plotly is not defined".
//
// We rewrite the loader URL to jsDelivr (which mirrors npm and serves all
// versions) at render time. Doing it here — rather than in the Python kernel —
// means existing saved charts (whose stored HTML already has the cdn.plot.ly
// URL baked in) are fixed on load without re-running the code cell.
//
// This is intended as a temporary shim: set `REWRITE_PLOTLY_CDN` to false to
// disable it once cdn.plot.ly serves all published plotly.js versions again.
export const REWRITE_PLOTLY_CDN = true;

const PLOTLY_CDN_RE = /https:\/\/cdn\.plot\.ly\/plotly-([\d.]+)\.min\.js/g;

/**
 * Rewrites cdn.plot.ly plotly.js loader URLs in chart HTML to jsDelivr. Returns
 * the input unchanged when the shim is disabled or no such URL is present.
 */
export const rewritePlotlyCdn = (html: string): string => {
  if (!REWRITE_PLOTLY_CDN) return html;
  return html.replace(PLOTLY_CDN_RE, 'https://cdn.jsdelivr.net/npm/plotly.js@$1/dist/plotly.min.js');
};
